export default function UpArrowIcon () {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M7.41 16.59L12 12L16.59 16.59L18 15.17L12 9.17L6 15.17L7.41 16.59Z" fill="currentColor" />
        </svg>
    )
}